import React from 'react';
import SavedQueries from '../components/SavedQueries';

function SavedQueriesRoute() {
  // Nothing to do here
  return <SavedQueries />;
}

export default SavedQueriesRoute;
